module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "controls"
    }
  }, [_c('button', {
    staticClass: "sub-btn",
    attrs: {
      "disabled": _vm.enableSubmit === false
    },
    on: {
      "click": _vm.submitAction
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
    staticClass: "shuffle-btn",
    on: {
      "click": _vm.shuffleQuestion
    }
  }, [_vm._v("Shuffle")]), _vm._v(" "), _c('button', {
    staticClass: "last-word",
    attrs: {
      "disabled": _vm.enableLastWord === false
    },
    on: {
      "click": _vm.lastWord
    }
  }, [_vm._v("Last Word")]), _vm._v(" "), _c('button', {
    staticClass: "clear-btn",
    on: {
      "click": _vm.clearAction
    }
  }, [_vm._v("Clear")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e5ddb74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Controls.vue
// module id = 28
// module chunks = 0